import { APIFetch, filterResponse, filterResponseBoolean } from '..'
import type { CreateTagPayload, TagData, TagInfo } from './types'

export type { CreateTagPayload, TagInfo, TagData }

export const getUserTags = async (userId: string): Promise<null | TagData[]> => {
  return filterResponse(
    await APIFetch(`/users/${userId}/elementals?elemental_type_id=10`, {
      method: 'GET',
    }),
  )
}
export const createTag = async (tag: CreateTagPayload): Promise<null | TagData> => {
  return filterResponse(
    await APIFetch('/elementals', {
      method: 'POST',
      body: tag,
    }),
  )
}
export const getElementalTags = async (productId: string): Promise<null | TagData[]> => {
  return filterResponse(
    await APIFetch(`/elementals/${productId}/tags`, {
      method: 'GET',
    }),
  )
}

export const setElementalTag = async (productId: string, tagId: string): Promise<null | TagData> => {
  return filterResponse(
    await APIFetch(`/elementals/${tagId}/items/${productId}`, {
      method: 'POST',
    }),
  )
}
export const removeElementalTag = async (productId: string, tagId: string): Promise<null | TagData> => {
  return filterResponse(
    await APIFetch(`/elementals/${tagId}/items/${productId}`, {
      method: 'DELETE',
    }),
  )
}

export const updateTag = async (tagId: string, tag: TagData): Promise<null | TagData> => {
  return filterResponse(
    await APIFetch(`/elementals/${tagId}`, {
      method: 'PUT',
      body: tag,
    }),
  )
}

export const deleteTag = async (tagId: string): Promise<boolean> => {
  return filterResponseBoolean(
    await APIFetch(`/elementals/${tagId}`, {
      method: 'DELETE',
    }),
  )
}

export const setApplyTagsToAllItems = async (productId: string): Promise<{ applyToAllItems: boolean } | null> => {
  return filterResponse(
    await APIFetch(`/elementals/${productId}/tags/toggle-replicate-to-all-items`, {
      method: 'PATCH',
    }),
  )
}

export const getApplyTagsToAllItems = async (productId: string): Promise<{ applyToAllItems: boolean } | null> => {
  return filterResponse(
    await APIFetch(`/elementals/${productId}/tags/replicate-to-all-items`, {
      method: 'GET',
    }),
  )
}

export const getTagInfo = async (tagId: string): Promise<null | TagInfo> => {
  return filterResponse(
    await APIFetch(`/elementals/${tagId}/tags/infos`, {
      method: 'GET',
    }),
  )
}
